export default {
      id: "oc-uis-usage",
      viewBox: "0 0 814 250",
      url: __webpack_public_path__ + "sprite.svg#oc-uis",
      toString: function () {
        return this.url;
      }
    }